module.exports = __webpack_public_path__ + "static/media/peep-empty.4f5c3a45.png";